export var UnobstructedMode;
(function (UnobstructedMode) {
    UnobstructedMode[UnobstructedMode["Center"] = 1] = "Center";
    UnobstructedMode[UnobstructedMode["Corners"] = 2] = "Corners";
})(UnobstructedMode || (UnobstructedMode = {}));
export var UnobstructedFaces;
(function (UnobstructedFaces) {
    UnobstructedFaces[UnobstructedFaces["X"] = 0] = "X";
    UnobstructedFaces[UnobstructedFaces["Y"] = 1] = "Y";
    UnobstructedFaces[UnobstructedFaces["Z"] = 2] = "Z";
})(UnobstructedFaces || (UnobstructedFaces = {}));
